export const hesaplaLupamatKodu = (ekranKodu, islemTuru) => {
  const ekran = parseInt(ekranKodu, 10);
  
  // Geçersiz giriş kontrolü
  if (isNaN(ekran) || ekran < 0) return "";

  // 1. V2028/V1028 Altı LCS500 Parametre (Çözüldü ✅)
  if (islemTuru === "lcs500") {
    const k = 87 
      + 256 * Math.floor(ekran / 128) 
      + 64 * (Math.floor(ekran / 32) % 2) 
      + 16 * (Math.floor(ekran / 8) % 2);
    
    let geriKod = (k - ekran) % 8192;
    
    // JavaScript'te negatif modülasyon olasılığına karşı güvenlik
    if (geriKod < 0) geriKod += 8192;
    
    return geriKod.toString().padStart(4, '0');
  }
  
  // 2. V2028/V1028 Altı Bakım Sıfırlama (Nihai Çözüm ✅)
  if (islemTuru === "bakim") {
    // Temel XOR sabiti: 1453 (Hex: 0x05AD)
    const baseXor = 1453;
    
    // Ekran kodu 8192 (0x2000) sınırını aşarsa, 
    // cihazın kendi mantığı gereği XOR anahtarına 8192 eklenir.
    // (ekran & 8192) işlemi, 8192'den küçükse 0, büyükse 8192 döndürür.
    const highBitMask = ekran & 8192; 
    
    // Nihael XOR anahtarını oluştur (1453 veya 9645)
    const finalXor = baseXor | highBitMask; 
    
    const geriKod = ekran ^ finalXor;
    
    return geriKod.toString().padStart(4, '0');
  }
  
  return "Formül henüz çözülmedi";
};